import React, { Component } from 'react';
import '../../App.scss';
import paymentService from '../../services/paymentService';
import CreditCard from '../../components/CreditCard/CreditCard';
import PaymentSelection from '../../components/PaymentSelection/PaymentSelection';
import ShoppingCart from '../../components/ShoppingCart/ShoppingCart';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Debit from '../../components/Debit/Debit';
import parameterService from '../../services/parameterService';
import languageService from '../../services/languageService'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 'credit-card',
            customFieldsAreUsed: parameterService.customFieldsAreUsed()
        };

        languageService.onChange(() => {
            this.forceUpdate()
        });
    }

    componentDidMount = () => {
        this.sidebar = document.querySelector('.details-sidebar');
    }

    onPaymentSelection = (selectedPayment) => {
        if (!selectedPayment) {
            return;
        }
        switch(selectedPayment) {
            case 'credit-card':
                paymentService.forwardToExternal('CC');
                return;
            case 'debit':
                paymentService.forwardToExternal('EDD');
                return;
            default:
                paymentService.forwardToExternal(selectedPayment);
        }
    };

    toggleSideBar = () => {
        this.sidebar.classList.toggle('is-collapsed');
    }

    render() {
        let leftPanel;
        let rightPanel = null;

        leftPanel = (<ShoppingCart/>);

        switch (this.state.step) {
            case 'selection':
                rightPanel = (<PaymentSelection onPaymentSelection={this.onPaymentSelection}/>);
                break;
            case 'credit-card':
                rightPanel = (<CreditCard onPaymentMeanChange={this.onPaymentSelection}/>);
                break;
            case 'debit':
                rightPanel = (<Debit onPaymentMeanChange={this.onPaymentSelection}/>);
                break;
            default:
                break;
        }

        return (
            <div className={
                [
                    'app-container',
                    'container-fluid',
                    this.state.customFieldsAreUsed ? " has-custom-fields" : null
                ].join(' ')
            }>
                <Header/>
                <div className={"App container" + (this.state.customFieldsAreUsed ? "": " no-background")}>
                    <div className="row ContentWrapper">
                        {this.state.customFieldsAreUsed && (
                            <div className="details-sidebar">
                                <button className="sidebar-toggle arrow-svg" onClick={this.toggleSideBar}></button>
                                {leftPanel}
                            </div>
                        )}
                        <div className={"page-container col-md-12"}>
                            {rightPanel}

                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/SelectionV2/App.js